let appMode = process.env.REACT_APP_ENV;
let ASSET_URL = "https://inventcolabs.s3.amazonaws.com/";
let URL;

console.log("appMode", appMode);

if (appMode === "development") {
  // URL = 'https://backend.dreambookpro.com/api/';
} else {
  // URL = "http://localhost:3369/api/";
  URL = "http://103.189.173.7:4020/api/";
}

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,

  transactionsSingle: "user/transaction/singleBySession",
  // Auth API
  login: "user/auth/login",
  loginOtp: "user/auth/login-Otp",
  logout: "user/auth/logout",
  signUp: "user/auth/sign-up",
  signUpNew: "user/auth/sign-up-new",
  verifyOtp: "user/auth/verify-otp",
  verifyAuthOtp: "user/auth/verify-otp-authenticate",
  resendOtp: "user/auth/resend-otp",
  generate2FA: "user/auth/generate2FA",
  verify2FA: "user/auth/verify2FA",
  forgotPassword: "user/auth/forget-password",
  resetPassword: "user/auth/reset-password",

  // contentPages

  contentPages: "admin/content/list",
  // user

  profile: "user/get-profile",
  updateProfile: "user/update-profile",
  getUserDetails: "user/details",
  changePassword: "user/change-password",
  uploadImage: "common/image-upload",

  // cards
  card: "user/cards",

  // Subscritpion

  subscribe: "user/subscription/subscribe-plan",
  sessionDetails: "user/subscription/get-session",
  allPlans: "user/subscription/subscriptions",

  subscriptionHistory: "user/transaction",
  transactionDetails: "user/transaction/details",
  getSubscription: "/user/subscription/get-subscription",
  cancelSubscription: "/user/subscription/cancel",

  // Dreams
  dreams: "user/dreams",
  addDream: "user/dreams/add",
  deleteDream: "user/dreams",
  fetchChat: "user/dreams/chat",
  sendMessage: "user/dreams/chat/send",
  question: "user/dreams/question",

  //  submit query
  submitQuery: "user/user-query",

  // Notifications

  notification: "user/notification",
};

export default apiPath;
